import { Routes } from "@angular/router";
import { orgAdminChildRoutes } from "../orgs/org-admin.routes";

/**
 * /admin — Customer-facing org/campus admin section.
 *
 * Distinct from /super (Classjax-internal staff). Anyone who is an admin of
 * at least one org sees this in the sidebar.
 *
 * The org + campus admin subtree is shared with /super/orgs (see
 * orgAdminChildRoutes) so Classjax staff can inspect any org with the same
 * UI customer admins use. Components consult AdminContextService to know
 * which root to use for breadcrumbs and back-links.
 */
export const adminRoutes: Routes = [
  {
    path: "admin",
    children: [
      // Directory landing — admin only; supers reach orgs via /super/orgs.
      {
        path: "",
        loadComponent: () =>
          import("../campuses/my-campus-list/campus-list.component").then(
            (m) => m.MyCampusListComponent,
          ),
      },
      ...orgAdminChildRoutes,
    ],
  },
];
